export type EstadoPedido =
  | 'PendienteDeConfirmacion'
  | 'Confirmado'
  | 'EnProceso'
  | 'Completado'
  | 'Cancelado';

export const TRANSICIONES_VALIDAS: Record<EstadoPedido, EstadoPedido[]> = {
  PendienteDeConfirmacion: ['Confirmado', 'Cancelado'],
  Confirmado: ['EnProceso', 'Cancelado'],
  EnProceso: ['Completado', 'Cancelado'],
  Completado: [],
  Cancelado: [],
};

export const ETIQUETAS_ESTADO: Record<EstadoPedido, string> = {
  PendienteDeConfirmacion: 'Pendiente de confirmación',
  Confirmado: 'Confirmado',
  EnProceso: 'En proceso',
  Completado: 'Completado',
  Cancelado: 'Cancelado',
};

export interface DatosContacto {
  nombre: string;
  telefono: string;
}

export interface HistorialEstadoEntry {
  estado: EstadoPedido;
  actorId: string;
  fechaHora: string;
}

export interface LineaPedido {
  productoId: string;
  nombreProductoSnapshot: string;
  paqueteId: string;
  nombrePaqueteSnapshot: string;
  cantidadDePaquetes: number;
  precioUnitarioPaqueteSnapshot: number;
  subtotal: number;
}

export interface Pedido {
  id: string;
  contacto: DatosContacto;
  lineas: LineaPedido[];
  estado: EstadoPedido;
  historialEstado: HistorialEstadoEntry[];
  totalPedido: number;
  fechaCreacion: string;
}

export interface RespuestaCheckout {
  pedido: Pedido;
  enlaceWhatsApp: string;
}
